import {html, render} from 'lit-html';

const justificationMarker = '<span class="has-justification"></span>';

const timelineEntry = (item, element, data) => `
  <p>${item.hasJustification ? justificationMarker : ""} ${item.content}</p>
`;

export {
  timelineEntry
}
